<template>
<div>
  <!-- <token-verification ref="refTokenVerification" /> -->

  <div v-if="confirmedUserName && !confirmedUserAnswer" class="container-reset-password">
    <securit-questions-verification
      ref="securityQuestionVerification"
      page-title="Reset Password"
      :security-questions="userSecurityQuestions"
      :verification-message="questionVerificationMessage"
      @validateAnswer="onValidateSecurityAnswer"
      :erorrMessage="questionVerificationMessage"
    />
  </div>
  <div v-if="confirmedUserAnswer" class="container-reset-password">
<div tabindex="0" class="e-card">
  <div class="e-card-title"> Update Password </div>
  <div class="e-card-content margin-color-verify-section">
    <web-login-info
                    ref="refwebLoginInfo"
                    :userProfileId="userId"
                    :userProfilesData="getUserDetail" />
    <div class="align-center-bottom">
      <ejs-button v-on:click.native="onCancelButtonClick"
                    cssClass="e-danger margin-button">Cancel</ejs-button>
      <ejs-button type="button" v-on:click.native="btnComplete"
                    cssClass="e-info margin-button">Submit</ejs-button>
    </div>
  </div>
  </div>
  </div>
</div>
</template>

<script>
import SecuritQuestionsVerification from '../components/security-questions-verification.vue';
import WebLoginInfo from '../../user-accounts/components/web-login-info.vue';
// import TokenVerification from '../components/token-varification.vue';

import {
  VALIDATE_SECURITY_ANSWER,
  FETCH_USER_SECURITY_QUESTIONS,
  LOCK_USER,
} from '../store';

export default {
  name: 'ResetPassword',
  components: {
    SecuritQuestionsVerification,
    WebLoginInfo,
    // TokenVerification,
  },
  data() {
    return {
      // tempTokenErrorMessage: null,
      questionVerificationMessage: null,
      confirmedUserAnswer: false,
      failAttempt: 0,
      questionCount: 3,
      userSecurityQuestions: [],
    };
  },
  computed: {
    confirmedUserName() {
      return this.$store.getters.confirmedUserName;
    },
    userSecurityAnswerStatus() {
      return this.$store.getters.userSecurityAnswerStatus;
    },
    getUserDetail() {
      return this.$store.getters.confirmedUser;
    },
    userId() {
      return this.$store.getters.confirmedUser ? this.$store.getters.confirmedUser.userId : null;
    },
  },
  mounted() {
    this.getUserSequrityQuestions(this.userId);
  },
  watch: {
    userId(newVal) {
      if (newVal) this.getUserSequrityQuestions(newVal);
    },
    userSecurityAnswerStatus(newVal) {
      if (newVal === 'SUCCESS') {
        this.confirmedUserAnswer = true;
      } else {
        if (newVal === 'FAILURE') this.failAttempt += 1;
        this.$refs.securityQuestionVerification.currentAnswer = null;
        if (this.questionCount === 0) {
          this.questionVerificationMessage = 'Your answer is incorrect. Your account has been locked. Please contact ASCA Storage Tanks to un-lock your account at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.';
        }
        this.questionVerificationMessage = `Your answer is incorrect. Please try again.  You have ${this.questionCount} attempts left or your account will be locked.  If you require assistance, please contact ASCA Storage Tanks at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca.`;
      }
      if (this.failAttempt >= 3) this.lockUser();
    },
  },
  methods: {
    onValidateSecurityAnswer({ securityQuestionId, answer, questionCount }) {
      const { userId } = this.$store.getters.confirmedUser;
      this.questionCount = questionCount;
      this.$store.dispatch(VALIDATE_SECURITY_ANSWER, { userId, securityQuestionId, answer });
    },
    async getUserSequrityQuestions(userId) {
      try {
        if (userId) {
          await this.$store.dispatch(FETCH_USER_SECURITY_QUESTIONS, { userId });
          this.userSecurityQuestions = this.$store.getters.userserSecurityQuestions;
        }
      } catch (err) {
        console.error('getUserSequrityQuestions ERROR', err);
      }
    },
    async lockUser() {
      try {
        // this.$parent.notificationToasts.length = 0;
        const userName = this.$store.getters.confirmedUserName;
        this.questionVerificationMessage = 'Your answer is incorrect. Your account has been locked. Please contact ASCA Storage Tanks to un-lock your account at 1-888-413-0099, #2 for ASCA then #2 for ASCA Storage Tanks or by email at ascatanks@safetycodes.ab.ca';
        await this.$store.dispatch(LOCK_USER, { userName }).then(
          this.$refs.securityQuestionVerification.isUserLocked = true,
          this.$parent.notificationToasts.push({
            title: 'Account Locked!',
            content: this.questionVerificationMessage,
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          }),
        );
        if (this.$parent.notificationToasts.length > 0) {
          this.$parent.$refs.notifierRef.show();
        }
      } catch (err) {
        console.error('getUserSequrityQuestions ERROR', err);
      }
    },
    onCancelButtonClick() {
      this.$router.push('/');
    },
    btnComplete() {
      // this.$parent.notificationToasts.length = 0;
      const loginInfo = this.$refs.refwebLoginInfo;
      // --Leo. this loginInfo.isConfirmPassword always return ture.
      // -- not fixed, just bring showConfirmPasswordMatch to join check for now.
      if (loginInfo.isPasswordValid && loginInfo.isConfirmPassword
      && loginInfo.showConfirmPasswordMatch) {
        loginInfo.resetPassword();
        this.$parent.notificationToasts.push({
          title: 'Success!',
          content: 'Your password has successfully changed. Please login using username and password.',
          cssClass: 'e-toast-success',
          timeOut: 5000,
        });
        this.$router.push('/login');
      } else {
        loginInfo.validatePassword();
        this.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Please enter correct passwod.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
  },
};
</script>
<style>
.container-reset-password {
  padding: 16px 10% 16px 10%;
}
</style>
